import "../../assets/styles/product-view.css";
import React, { useEffect } from "react";
import image from "../../assets/images/221130_appstore_headerbilder.jpg";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import Banner from "../../components/Banner/Banner";
import img_ClearVAT from "../../assets/images/ClearVAT.jpg";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import Team from "../../components/Team/Team";
import MatchingProducts from "../../components/MatchingProducts/MatchingProducts";
import { setLang } from "../../redux/actions/settings";
import { useNavigate, useParams } from "react-router-dom";

const Product = () => {
  const lang = useSelector((state) => state.settings.lang);

  const { language } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (language === "de" || language === "en") {
      dispatch(setLang(language));
    } else {
      navigate("/not-found");
    }
  }, []);

  useEffect(() => {
    document.title =
      "ClearVAT: VAT clearing rethought for European e-commerce | eClear AG";
  }, []);
  return (
    <div>
      <div>
        <BreadCrumbs
          navItems={[
            {
              title: "eClear Store",
              href: `/store/${language}`,
            },
            {
              title: "VAT Suite",
              href: `/store/${language}/vat-suite`,
            },
            {
              title: "ClearVAT",
            },
          ]}
        />
      </div>
      <div>
        <div>
          <div className="column main">
            <Banner
              image={image}
              title={"ClearVAT"}
              productImage={img_ClearVAT}
            />
            <input
              name="form_key"
              type="hidden"
              defaultValue="Sk3VlxqpWwfVfRQk"
            />
            <div
              id="authenticationPopup"
              data-bind="scope:'authenticationPopup', style: {display: 'none'}"
              style={{ display: "none" }}
            ></div>
            <div className="catalog-product-view ">
              <div className="product-infomation-wrapper">
                <input type="hidden" id="storeId" defaultValue={1} />
                <input type="hidden" id="currencySymbol" defaultValue="€" />
                <div className="product-information">
                  <div className="box-left">
                    <div className="use-case">
                      <h3 className="title">Use case</h3>
                      <FormattedMessage id="VATRules.useCase" />
                    </div>
                    <div className="features-and-benefits">
                      <div className="features">
                        <h3 className="title">Feature</h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage id="VATRules.feature1" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.feature2" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.feature3" />
                          </li>
                        </ul>{" "}
                      </div>
                      <div className="benefits">
                        <h3 className="title">Benefit</h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage id="VATRules.benefit1" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.benefit2" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.benefit3" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.benefit4" />
                          </li>
                          {lang === "de" && (
                            <li>
                              <FormattedMessage id="VATRules.benefit5" />
                            </li>
                          )}
                        </ul>{" "}
                      </div>
                    </div>
                    <Team />
                  </div>
                  <div className="box-right">
                    {/* REQUEST BUTTON */}
                    <form action=" https://eclear.com/contact/" method="get">
                      {/* <form action="https://eclear.com/contact/" method="post"> */}
                      <div className="box-to-cart">
                        <span>
                          <FormattedMessage id="Request quotation" />
                        </span>
                        <button
                          className="action subscribe primary request-demo-now-header"
                          type="submit"
                        >
                          <FormattedMessage id="Reuqest offer" />
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <MatchingProducts />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Product;
